import _classCallCheck from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _get from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/inherits";

/**
@license
Copyright (c) 2017 Vaadin Ltd.
This program is available under Apache License Version 2.0, available at https://vaadin.com/license/
*/

/**
 * @polymerMixin
 */
export var ProgressMixin = function ProgressMixin(superClass) {
  return (
    /*#__PURE__*/
    function (_superClass) {
      _inherits(VaadinProgressMixin, _superClass);

      function VaadinProgressMixin() {
        _classCallCheck(this, VaadinProgressMixin);

        return _possibleConstructorReturn(this, _getPrototypeOf(VaadinProgressMixin).apply(this, arguments));
      }

      _createClass(VaadinProgressMixin, [{
        key: "ready",
        value: function ready() {
          _get(_getPrototypeOf(VaadinProgressMixin.prototype), "ready", this).call(this);

          this.setAttribute('role', 'progressbar');
        }
      }, {
        key: "_normalizedValueChanged",
        value: function _normalizedValueChanged(value, min, max) {
          var newNormalizedValue = this._normalizeValue(value, min, max);

          this.style.setProperty('--vaadin-progress-value', newNormalizedValue);
          this.updateStyles({
            '--vaadin-progress-value': String(newNormalizedValue)
          });
        }
      }, {
        key: "_valueChanged",
        value: function _valueChanged(newV, oldV) {
          this.setAttribute('aria-valuenow', newV);
        }
      }, {
        key: "_minChanged",
        value: function _minChanged(newV, oldV) {
          this.setAttribute('aria-valuemin', newV);
        }
      }, {
        key: "_maxChanged",
        value: function _maxChanged(newV, oldV) {
          this.setAttribute('aria-valuemax', newV);
        }
        /**
         * Percent of current progress relative to whole progress bar (max - min)
         */

      }, {
        key: "_normalizeValue",
        value: function _normalizeValue(value, min, max) {
          var nV;

          if (!value && value != 0) {
            nV = 0;
          } else if (min >= max) {
            nV = 1;
          } else {
            nV = (value - min) / (max - min);
            nV = Math.min(Math.max(nV, 0), 1);
          }

          return nV;
        }
      }], [{
        key: "properties",
        get: function get() {
          return {
            /**
             * Current progress value.
             */
            value: {
              type: Number,
              observer: '_valueChanged'
            },

            /**
             * Minimum bound of the progress bar.
             */
            min: {
              type: Number,
              value: 0,
              observer: '_minChanged'
            },

            /**
             * Maximum bound of the progress bar.
             */
            max: {
              type: Number,
              value: 1,
              observer: '_maxChanged'
            },

            /**
             * Indeterminate state of the progress bar.
             * This property takes precedence over other state properties (min, max, value).
             */
            indeterminate: {
              type: Boolean,
              value: false,
              reflectToAttribute: true
            }
          };
        }
      }, {
        key: "observers",
        get: function get() {
          return ['_normalizedValueChanged(value, min, max)'];
        }
      }]);

      return VaadinProgressMixin;
    }(superClass)
  );
};